module.exports = __webpack_public_path__ + "media/images/countrysquared/uy-12cb8f5f9a631c7d5ff1f3fbc8280c2a.svg";